import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import DmsDashboard from './DmsDashboard';

const DmsDashboardWrapper = (props) => {
    const { themeSelected, onThemechange } = props;

    return (
        <div className="container-fluid">
            <Header {...props} />
            {/* <Navigationbar {...props} /> */}
            <div className="content-wrapper">
                <DmsDashboard themeSelected={themeSelected} />
            </div>
        </div>
    );
};

export default DmsDashboardWrapper;